module.exports = __webpack_public_path__ + "img/rxk_img2.4214fbed.png";